import Button from "../../../../components/button/Button";
import { BUTTON_TYPE } from "../../../../components/button/constants";
import BasicCard from "../../../../components/card/basiccard/BasicCard";
import SelectDropdown from "../../../../components/dropdown/selectdropdown/SelectDropdown";
import Label from "../../../../components/label/Label";
import { setIsPaymentNotMapped, setSelectedPayer, setUploadedFilePath } from "./TipaltiSlice";
import { processTipaltiTokenUpdate, getPayersList, getTipaltiRedirectUrl, getPayerEntityFilters, getFormAndTaxYearList, getTipaltiLoadOrImportData, getLoadImportData, getFormLabels, getFormSetting } from "./TipaltiSaga";
import tipaltiStyles from "./Tipalti.styles";
import { useDispatch, useSelector } from "react-redux";
import { componentKey } from "./TipaltiSlice";
import { useEffect, useState } from "react";
import General from "../../../../../libs/utility/General";
import { useSearchParams } from "react-router-dom";
import { FORM_IDS, INTEGRATION_CONSTANTS, SOURCE_CONSTANTS, TIPALTI_LOADING_STATES, TIPALTI_LOADING_STATES_MESSAGE_MAP } from "../constants";
import TipaltiNewUserAccountSetup from "./TipaltiNewUserAccountSetup";
import { VEC_ICON_NAME } from "../../../../components/icons/constants";
import TextInput from "../../../../components/input/textinput/TextInput";
import CheckboxWLabel from "../../../../components/checkbox/checkboxwlabel/CheckboxWLabel";
import MultiSelectDropdown from "../../../../components/multiselect/multiselectdropdown/MultiSelectDropdown";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import InformationPopup from "../../../../components/popup/informationpopup/InformationPopup";
import FormAttachmentUpload from "../../../components/formattachmentupload.js/FormAttachmentUpload";
import Popup from "../../../../components/popup/Popup";
import ImportDataGridView from "../../../components/importdatagridview/ImportDataGridView";
import { INTEGRATION_ROUTES } from "../../../constants/constants";
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
import Loadable from "../../../../components/loadable/Loadable";


export default function Tipalti() {
    const [selectedTipaltiPayer, setSelectedTipaltiPayer] = useState({});
    const [mappedTax1099Payer, setMappedTax1099Payer] = useState('');
    const [taxYearOptions, setTaxYearOptions] = useState([]);
    const [formOptions, setFormOptions] = useState([]);
    const [selectedTaxYear, setSelectedTaxYear] = useState('');
    const [selectedForm, setSelectedForm] = useState('');
    const [selectedCheckbox, setSelectedCheckbox] = useState('');
    const [storedPayerData, setStoredPayerData] = useState([]);
    const [selectedDropdownFilterOptions, setSelectedDropdownFilterOptions] = useState([]);
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [isFilterOutInfoPopUp, setIsFilterOutInfoPopUp] = useState(false);
    const [isFilterIn, setIsFilterIn] = useState(false);
    const [popupDropdownOptions, setPopupDropdownOptions] = useState([]);
    const [popupDropdownselectedOption, setPopupDropdownselectedOption] = useState('');
    const { payersList, selectedPayer, tipaltiRedirectUrl, businessNameList, formAndTaxYearList, payerEntityFilters,
        uploadedFilePath, isPaymentNotMapped, formBoxLabels, isImportDataGridViewLoaded, importData, formSettings, loadingState } = useSelector(state => state[componentKey]);
    const [queryParams, setQueryParams] = useSearchParams();
    const dispatch = useDispatch();


    useEffect(() => {
        if (payersList.length === 0) {
            dispatch(getPayersList());
        }
        dispatch(getFormLabels());
    }, []);

    useEffect(() => {
        if (formAndTaxYearList) {
            setTaxYearOptions(formAndTaxYearList.TaxYear);
            setFormOptions(formAndTaxYearList.FormType);
        }
    }, [formAndTaxYearList]);

    useEffect(() => {
        if (selectedTipaltiPayer) {
            const payer = payersList.find(item => item.PayerDetailId === selectedTipaltiPayer.value);
            setMappedTax1099Payer(payer ? payer.LastName : '');
        }
        else {
            setMappedTax1099Payer('');
        }
        dispatch(getFormAndTaxYearList());
    }, [selectedTipaltiPayer])

    useEffect(() => {
        if (tipaltiRedirectUrl) {
            if (storedPayerData) {
                General.setLocalStorageItem(
                    INTEGRATION_CONSTANTS.PAYERDATA_SESSION_KEY,
                    storedPayerData,
                    INTEGRATION_CONSTANTS.LOCAL_STORAGE_TTL
                );
            }
            General.setLocalStorageItem(
                INTEGRATION_CONSTANTS.PAYERDATA_SESSION_KEY,
                selectedPayer,
                INTEGRATION_CONSTANTS.LOCAL_STORAGE_TTL
            );
            window.location.href = tipaltiRedirectUrl;
        }
    }, [tipaltiRedirectUrl]);

    useEffect(() => {
        if (selectedFilters.length > 0) {
            setIsFilterOutInfoPopUp(true);
        }
        else {
            setIsFilterOutInfoPopUp(false);
        }
    }, [selectedFilters])

    useEffect(() => {
        setFilterData(selectedFilters.flatMap(item => (
            item.values.map(value => ({
                key: item.key,
                value: value[0]
            }))
        )));
    }, [selectedFilters]);

    useEffect(() => {
        if (formBoxLabels && formBoxLabels[selectedForm]) {

            var dropdownOptions = formBoxLabels[selectedForm].map(item => ({
                label: item.Label,
                value: item.Label
            }));
            setPopupDropdownOptions(dropdownOptions);
        }
    }, [formBoxLabels, selectedForm]);

    useEffect(() => {
        if (importData) {
            dispatch(getFormSetting({
                formId: selectedForm,
                year: selectedTaxYear
            }));
        }
    }, [importData]);

    useEffect(() => {
        const selected1099Payer = General.getLocalStorageItem(INTEGRATION_CONSTANTS.PAYERDATA_SESSION_KEY);

        if (selected1099Payer) {
            setStoredPayerData(selected1099Payer);
        }

        if (queryParams.has(INTEGRATION_CONSTANTS.URL_CODE) && queryParams.has(INTEGRATION_CONSTANTS.URL_SCOPE) && queryParams.has(INTEGRATION_CONSTANTS.URL_STATE)) {
            const qboToken = queryParams.get(INTEGRATION_CONSTANTS.URL_CODE);
            const scope = queryParams.get(INTEGRATION_CONSTANTS.URL_SCOPE);
            const businessId = selected1099Payer ? selected1099Payer.PayerDetailId : '';
            const payerName = selected1099Payer ? selected1099Payer.label : '';
            dispatch(processTipaltiTokenUpdate({
                tipaltiQueryParam: {
                    Code: qboToken,
                    Scope: scope,
                    State: "",
                    BusinessId: businessId,
                    PayerName: payerName,
                    Source: SOURCE_CONSTANTS.TIPALTI_SOURCE
                }
            }));
            queryParams.delete(INTEGRATION_CONSTANTS.URL_CODE);
            queryParams.delete(INTEGRATION_CONSTANTS.URL_SCOPE);
            if (queryParams.has(INTEGRATION_CONSTANTS.URL_STATE)) {
                queryParams.delete(INTEGRATION_CONSTANTS.URL_STATE);
            }
            if (queryParams.has(INTEGRATION_CONSTANTS.URL_ISS)) {
                queryParams.delete(INTEGRATION_CONSTANTS.URL_ISS);
            }
            setQueryParams(queryParams);
        } else if (queryParams.has(INTEGRATION_CONSTANTS.URL_ERROR)) {
            queryParams.delete(INTEGRATION_CONSTANTS.URL_ERROR);
            if (queryParams.has(INTEGRATION_CONSTANTS.URL_STATE)) {
                queryParams.delete(INTEGRATION_CONSTANTS.URL_STATE);
            }
            setQueryParams(queryParams);
        } else {
            dispatch(processTipaltiTokenUpdate({
                tipaltiQueryParam: {
                    Code: '',
                    Scope: '',
                    State: '',
                    BusinessId: '',
                    PayerName: '',
                    Source: SOURCE_CONSTANTS.TIPALTI_SOURCE
                }
            }));
        }
    }, []);

    const handleCheckboxChange = (value) => {

        if (selectedTipaltiPayer.value) {
            if (value === INTEGRATION_CONSTANTS.PAYER_TYPE && payerEntityFilters.length === 0) {
                dispatch(getPayerEntityFilters(selectedTipaltiPayer?.value))
            }
        }
        else {
            dispatch(addNotifications({
                heading: "Required field missing",
                message: "Please choose a TipaltiPayer to proceed"
            }));
            return;
        }

        if (selectedCheckbox === value) {
            setSelectedCheckbox('');
        } else {
            setSelectedCheckbox(value);
        }
    };

    const handleAddClick = () => {
        const newFilter = {
            key: selectedCheckbox,
            values: selectedDropdownFilterOptions.map(option => option.label.split(',')),
        };

        setSelectedFilters(prevFilters => {
            const existingFilterIndex = prevFilters.findIndex(filter => filter.key === newFilter.key);
            if (existingFilterIndex !== -1) {
                const updatedFilters = [...prevFilters];
                updatedFilters[existingFilterIndex] = newFilter;
                return updatedFilters;
            } else {
                return [...prevFilters, newFilter];
            }
        });
    };
    const handleRemoveFilter = (index) => {
        const updatedFilters = [...selectedFilters];
        updatedFilters.splice(index, 1);
        setSelectedFilters(updatedFilters);
    };

    const handleCommonBtnClick = (isImport) => {
        if (selectedForm && selectedTaxYear && (isImport ? uploadedFilePath : true)) {
            dispatch(getTipaltiLoadOrImportData({
                tipatiModel: {
                    IsTipaltiImport: isImport,
                    FilterIn: isFilterIn,
                    FilterData: filterData,
                    TaxYear: selectedTaxYear,
                    FormName: selectedForm,
                    ImportFilePath: isImport ? uploadedFilePath : '',
                    PayerId: selectedTipaltiPayer?.value
                }
            }));
        } else {
            dispatch(addNotifications({
                heading: "Required field missing",
                message: `Please choose a ${isImport ? 'selectedTaxYear, select Tipalti Payer, and upload file' : 'selectedTaxYear and select Tipalti Payer'} to proceed`
            }));
        }
    };

    const handleToClickProceedBtn = () => {
        if (selectedTaxYear && selectedForm && selectedTipaltiPayer?.value) {
            dispatch(getLoadImportData(
                {
                    integrationImportRequestDto: {
                        TaxYear: selectedTaxYear,
                        FormName: selectedForm,
                        Source: SOURCE_CONSTANTS.TIPALTI_SOURCE,
                        TipatiModelData: {
                            IsTipaltiImport: false,
                            FilterIn: isFilterIn,
                            FilterData: filterData,
                            TaxYear: selectedTaxYear,
                            FormName: selectedForm,
                            ImportFilePath: '',
                            PayerId: selectedTipaltiPayer?.value,
                            MappingFormBoxes: popupDropdownselectedOption
                        }
                    }
                }));
        }
        else {
            dispatch(addNotifications({
                heading: "Required fields missing",
                message: "Please choose tax year and form type to proceed"
            }));
        }
    };

    const handlePullDataBtnClick = () => {
        handleCommonBtnClick(false);
    };

    const handleLoadBtnClick = () => {
        handleCommonBtnClick(true);
    };
    const handlePopupClose = () => {
        dispatch(setIsPaymentNotMapped(false))
    }

    const checkboxOptions = [
        { label: INTEGRATION_CONSTANTS.ENTITY_TYPE, value: INTEGRATION_CONSTANTS.ENTITY_TYPE },
        { label: INTEGRATION_CONSTANTS.PAYER_TYPE, value: INTEGRATION_CONSTANTS.PAYER_TYPE },
    ];

    const getFilterDropdownOptions = () => {
        if (selectedCheckbox === INTEGRATION_CONSTANTS.ENTITY_TYPE) {
            return [
                { label: INTEGRATION_CONSTANTS.INDIVIDUAL, value: INTEGRATION_CONSTANTS.INDIVIDUAL, checked: selectedDropdownFilterOptions.some(option => option.value === INTEGRATION_CONSTANTS.INDIVIDUAL) },
                { label: INTEGRATION_CONSTANTS.CCORP, value: INTEGRATION_CONSTANTS.CCORP, checked: selectedDropdownFilterOptions.some(option => option.value === INTEGRATION_CONSTANTS.CCORP) },
                { label: INTEGRATION_CONSTANTS.SCORP, value: INTEGRATION_CONSTANTS.SCORP, checked: selectedDropdownFilterOptions.some(option => option.value === INTEGRATION_CONSTANTS.SCORP) },
                { label: INTEGRATION_CONSTANTS.PARTNERSHIP, value: INTEGRATION_CONSTANTS.PARTNERSHIP, checked: selectedDropdownFilterOptions.some(option => option.value === INTEGRATION_CONSTANTS.PARTNERSHIP) },
                { label: INTEGRATION_CONSTANTS.LLC, value: INTEGRATION_CONSTANTS.LLC, checked: selectedDropdownFilterOptions.some(option => option.value === INTEGRATION_CONSTANTS.LLC) },
                { label: INTEGRATION_CONSTANTS.TRUST, value: INTEGRATION_CONSTANTS.TRUST, checked: selectedDropdownFilterOptions.some(option => option.value === INTEGRATION_CONSTANTS.TRUST) },
                { label: INTEGRATION_CONSTANTS.OTHER, value: INTEGRATION_CONSTANTS.OTHER, checked: selectedDropdownFilterOptions.some(option => option.value === INTEGRATION_CONSTANTS.OTHER) },
            ];
        } else if (selectedCheckbox === INTEGRATION_CONSTANTS.PAYER_TYPE) {
            if (payerEntityFilters) {
                return payerEntityFilters.map(entity => ({
                    label: entity,
                    value: entity
                }));
            }
        }
        return [];
    };

    const breadcrumbItems = [
        { text: 'Home', link: '/' },
        { text: 'Import', link: `/${INTEGRATION_ROUTES.IMPORT}` },
        { text: 'tipalti', link: `/${INTEGRATION_ROUTES.IMPORT}/${INTEGRATION_ROUTES.TIPALTI}` },
    ];


    return (
        <>
            <Breadcrumbs items={breadcrumbItems} />
            {(formSettings && selectedTaxYear && selectedForm && isImportDataGridViewLoaded) ? (
                <ImportDataGridView
                    isStateFilingApplicable={false}
                    filingForCorrected={false}
                    formSettings={formSettings}
                    formName={selectedForm}
                    formId={
                        (() => {
                            switch (selectedForm) {
                                case INTEGRATION_CONSTANTS.NEC_FORM:
                                    return FORM_IDS.$1099NEC;
                                case INTEGRATION_CONSTANTS.MISC_FORM:
                                    return FORM_IDS.$1099MISC;
                                default:
                                    return null;
                            }
                        })()
                    }
                    taxYear={selectedTaxYear}
                />
            ) : (
                <>
                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={TIPALTI_LOADING_STATES.PAGE_LOADING}
                        messageMap={TIPALTI_LOADING_STATES_MESSAGE_MAP}
                        isNewLoadable={true}
                    >
                        <div style={tipaltiStyles.container}>
                            <div style={tipaltiStyles.leftSide}>
                                <BasicCard>
                                    <div style={tipaltiStyles.sectionHeader}>Connect your Tipalti Payer</div>
                                    <div style={tipaltiStyles.cardContent}>
                                        <Loadable
                                            currentState={loadingState.state}
                                            loadingStates={TIPALTI_LOADING_STATES.DROPDOWNS_LOADING}
                                            messageMap={TIPALTI_LOADING_STATES_MESSAGE_MAP}
                                            isNewLoadable={true}
                                        >
                                            <div style={tipaltiStyles.selectPayerContainer}>
                                                <Label style={tipaltiStyles.label}>Select Payer:</Label>
                                                <SelectDropdown
                                                    placeHolder="Choose your Payer"
                                                    value={{ label: selectedPayer.label || '', value: selectedPayer.value || '' }}
                                                    options={payersList}
                                                    onSelectCb={(name, selectedOption) => dispatch(setSelectedPayer(selectedOption))}

                                                />
                                            </div>
                                        </Loadable>
                                        <div>
                                            <div style={tipaltiStyles.marginTop}>
                                                <Label style={tipaltiStyles.label}>
                                                    Payer Name: <span style={tipaltiStyles.value}>{selectedPayer.label}</span>
                                                </Label>
                                            </div>
                                            <div style={{ ...tipaltiStyles.marginTop, ...tipaltiStyles.marginBottom }}>
                                                <Label style={tipaltiStyles.label}>
                                                    TIN Number: <span style={tipaltiStyles.value}>{selectedPayer.value}</span>
                                                </Label>
                                            </div>
                                        </div>
                                        <Button
                                            type={BUTTON_TYPE.PRIMARY}
                                            title="Connect"
                                            onClickCb={() => dispatch(getTipaltiRedirectUrl())}
                                        >
                                            Connect
                                        </Button>
                                    </div>
                                </BasicCard>
                                <BasicCard>
                                    <div style={tipaltiStyles.sectionHeader}>Load 1099 Filing Data</div>
                                    <div style={tipaltiStyles.cardContent}>
                                        <div style={tipaltiStyles.filterRow}>
                                            <Loadable
                                                currentState={loadingState.state}
                                                loadingStates={TIPALTI_LOADING_STATES.DROPDOWNS_LOADING}
                                                messageMap={TIPALTI_LOADING_STATES_MESSAGE_MAP}
                                                isNewLoadable={true}
                                            >
                                                <div style={tipaltiStyles.flex}>
                                                    <Label>Choose your Tipalti Payer:</Label>
                                                    <SelectDropdown
                                                        placeHolder="Select Tipalti Payer"
                                                        name="Choose your Tipalti Payer"
                                                        value={{ label: selectedTipaltiPayer.label, value: selectedTipaltiPayer.label }}
                                                        options={businessNameList}
                                                        onSelectCb={(name, selectedOption) => setSelectedTipaltiPayer(selectedOption)}
                                                        customInputStyles={tipaltiStyles.dropdownMarginLeft}

                                                    />
                                                </div>
                                            </Loadable>
                                            <Loadable
                                                currentState={loadingState.state}
                                                loadingStates={TIPALTI_LOADING_STATES.DROPDOWNS_LOADING}
                                                messageMap={TIPALTI_LOADING_STATES_MESSAGE_MAP}
                                                isNewLoadable={true}
                                            >
                                                <div style={tipaltiStyles.flex}>
                                                    <Label>Tax Year:</Label>
                                                    <SelectDropdown
                                                        label=""
                                                        placeHolder="Select taxYear"
                                                        name="Tax Year"
                                                        value={{ label: selectedTaxYear || '', value: selectedTaxYear || '' }}
                                                        options={taxYearOptions}
                                                        onSelectCb={(name, selectedOption) => setSelectedTaxYear(selectedOption.value)}
                                                        suffixProps={{ icon: VEC_ICON_NAME.ICON_DROPDOWN_CARET }}
                                                        customInputStyles={tipaltiStyles.dropdownMarginLeft}
                                                    />
                                                </div>
                                            </Loadable>
                                        </div>
                                        <div style={tipaltiStyles.filterRow}>
                                            <Loadable
                                                currentState={loadingState.state}
                                                loadingStates={TIPALTI_LOADING_STATES.DROPDOWNS_LOADING}
                                                messageMap={TIPALTI_LOADING_STATES_MESSAGE_MAP}
                                                isNewLoadable={true}
                                            >
                                                <div style={tipaltiStyles.flex}>
                                                    <Label style={tipaltiStyles.label}>Form Name:</Label>
                                                    <SelectDropdown
                                                        label=""
                                                        placeHolder="Select Form"
                                                        name="Form Name"
                                                        value={{ label: selectedForm || '', value: selectedForm || '' }}
                                                        options={formOptions}
                                                        onSelectCb={(name, selectedOption) => setSelectedForm(selectedOption.value)}
                                                        suffixProps={{ icon: VEC_ICON_NAME.ICON_DROPDOWN_CARET }}
                                                        customInputStyles={tipaltiStyles.dropdownMarginLeft}
                                                    />
                                                </div>

                                                <div style={tipaltiStyles.flex}>
                                                    <Label>Mapped to Tax1099 Payer:</Label>
                                                    <TextInput
                                                        placeHolder="Selected Tax1099 Payer"
                                                        value={mappedTax1099Payer}
                                                        customStyles={tipaltiStyles.dropdownMarginLeft}
                                                        onChange={(e) => setMappedTax1099Payer(e.target.value)}
                                                        disabled={true}
                                                    />
                                                </div>
                                            </Loadable>
                                        </div>
                                        {
                                            <InformationPopup
                                                title={"Filters Information"}
                                                bodyText={"By default, the filters are set to Filter-out. If you need to switch to Filter-In, please check the  below Checkbox(Filter-In) and proceed further"}
                                                iconName={VEC_ICON_NAME.INFO_ICON}
                                                isOpen={isFilterOutInfoPopUp}
                                                confirmationButtonProps={{
                                                    onConfirmationCb: () => (setIsFilterOutInfoPopUp(false)),
                                                    confirmationButtonText: "Ok",
                                                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                                                }}
                                                showClose={false}
                                            />
                                        }
                                        <div style={tipaltiStyles.sectionHeader}>Set Filters</div>
                                        <div style={tipaltiStyles.filtersContainer}>
                                            <div style={tipaltiStyles.flex}>
                                                <div style={tipaltiStyles.checkboxMargin}>
                                                    {checkboxOptions.map(option => (
                                                        <div style={tipaltiStyles.filterRow}>
                                                            <div style={tipaltiStyles.flex}>
                                                                <CheckboxWLabel
                                                                    label={option.label}
                                                                    value={option.value}
                                                                    checked={selectedCheckbox === option.value}
                                                                    onChangeCb={() => handleCheckboxChange(option.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                            <div style={tipaltiStyles.filtersContainer}>
                                                <div style={tipaltiStyles.filtersDropdown}>
                                                    <MultiSelectDropdown
                                                        onSelectOptionsCb={(selectedOption) => setSelectedDropdownFilterOptions(selectedOption)}
                                                        options={getFilterDropdownOptions()}
                                                        customInputStyles={tipaltiStyles.dropdownMarginLeft}
                                                        isDisabled={selectedCheckbox === ''}
                                                    />
                                                </div>
                                                <Button
                                                    type={BUTTON_TYPE.PRIMARY}
                                                    onClickCb={handleAddClick}
                                                    disabled={selectedCheckbox === '' || selectedDropdownFilterOptions.length === 0}
                                                    style={tipaltiStyles.dropdownMarginLeft}
                                                >
                                                    Add
                                                </Button>
                                            </div>
                                        </div>
                                        <div style={tipaltiStyles.selectedFiltersCard}>
                                            {selectedFilters.map((filter, index) => (
                                                <BasicCard>
                                                    <div key={index} style={tipaltiStyles.filterContainer}>
                                                        <div style={tipaltiStyles.filterDetails}>
                                                            <span>{filter.key}: {filter.values.join(',')}</span>
                                                            <Button
                                                                type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                                                                onClickCb={() => handleRemoveFilter(index)}
                                                                style={tipaltiStyles.removeFilterButton}
                                                            >
                                                                X
                                                            </Button>
                                                        </div>
                                                    </div>

                                                    <div style={tipaltiStyles.filterRow}>
                                                        <div style={tipaltiStyles.flex}>
                                                            <CheckboxWLabel
                                                                label="Filter-In"
                                                                checked={isFilterIn}
                                                                onChangeCb={() => setIsFilterIn(prev => !prev)}
                                                            />
                                                        </div>
                                                    </div>
                                                </BasicCard>
                                            ))}
                                        </div>
                                        {uploadedFilePath ?

                                            (
                                                <div style={tipaltiStyles.buttonRow}>
                                                    <Button onClickCb={handleLoadBtnClick}>Load</Button>
                                                </div>
                                            )
                                            : (
                                                <div style={tipaltiStyles.buttonRow}>
                                                    <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={handlePullDataBtnClick}>Pull the Data from Tipalti now</Button>
                                                    <span style={tipaltiStyles.spanLabel}>OR</span>
                                                    <FormAttachmentUpload
                                                        name='Import Data using Tipalti 1099'
                                                        allowedFileTypes={['.xls', '.xlsx', '.csv']}
                                                        addAttachmentBtnLabel='Import Data using Tipalti 1099'
                                                        showRemoveBtn={false}
                                                        onChangeCb={(uploadFileData) => { dispatch(setUploadedFilePath(uploadFileData?.FilePath)) }}
                                                    />
                                                </div>
                                            )
                                        }
                                    </div>
                                </BasicCard>
                                {
                                    <Popup
                                        title='Missing Box Mapping'
                                        isPopupOpen={isPaymentNotMapped}
                                        onCloseCb={handlePopupClose}
                                        showClose={true}
                                        showHeader={true}
                                        customPopupSyles={tipaltiStyles.popupStyle}
                                        customPopupHeaderStyles={tipaltiStyles.popupHeaderStyle}
                                    >
                                        {isPaymentNotMapped &&
                                            <>
                                                <div style={tipaltiStyles.marginBottom}>
                                                    <strong>
                                                        Warning: Your import from Tipalti has uncategorized payments. You can map all of the uncategorized amounts to one box on this page by using the "Form Boxes" drop-down menu below. Or you can download the excel file on this popup screen called "Payments not Mapped". You can use this file to correctly map the amounts in your Tipalti account before pulling the 1099 report again.
                                                    </strong>
                                                </div>
                                                <Loadable
                                                    currentState={loadingState.state}
                                                    loadingStates={TIPALTI_LOADING_STATES.DROPDOWNS_LOADING}
                                                    messageMap={TIPALTI_LOADING_STATES_MESSAGE_MAP}
                                                    isNewLoadable={true}
                                                >
                                                    <div style={tipaltiStyles.popupDropdownContainer}>
                                                        <SelectDropdown
                                                            label="Form Boxes"
                                                            placeHolder="Select Box"
                                                            name="Form Boxes"
                                                            value={{ label: popupDropdownselectedOption || '', value: popupDropdownselectedOption || '' }}
                                                            options={popupDropdownOptions}
                                                            onSelectCb={(name, selectedOption) => setPopupDropdownselectedOption(selectedOption.value)}
                                                            suffixProps={{ icon: VEC_ICON_NAME.ICON_DROPDOWN_CARET }}
                                                            dropdownMenuStyle={tipaltiStyles.popupDropdownWidth}
                                                            dropdownContainerStyles={tipaltiStyles.popupDropdownWidth}
                                                        />
                                                    </div>
                                                </Loadable>
                                                <div style={tipaltiStyles.popupBtnContainer}>
                                                    <Button onClickCb={handleToClickProceedBtn}>Proceed</Button>
                                                    <Button
                                                        style={tipaltiStyles.popupCancelBtn}
                                                        onClickCb={handlePopupClose}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </div>
                                            </>
                                        }
                                    </Popup>
                                }

                            </div>
                            <div style={tipaltiStyles.rightSide}>
                                <TipaltiNewUserAccountSetup />
                            </div>
                        </div>
                    </Loadable>
                </>

            )}
        </>
    );
}